@if (this.user) {
  <div (click)="this.close($event)"
    class="modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2"
    style="z-index: 999; position: fixed">
    <div class="bg-white w-full h-full max-h-[650px] max-w-[1000px] rounded overflow-y-auto flex flex-col fadeIn relative">
      <mk-icon-button  (click)="this.close(null)" class="md:!hidden aspect-square w-[50px] scale-80 absolute right-4 top-4 z-10" [fullscale]="true" direction="rtl" icon="cancel" useSvg="false" [label]="''" />
      <div class="w-full p-3 relative flex items-start items-center gap-2 flex-col md:flex-row">
        <div class="p-2 rounded bg-vert-3">
          <svg class="fg-vert-1 w-6 h-6 text-lg">
            <use href="/assets/images/icons/icons.svg#service"></use>
          </svg>
        </div>
        <p class="font-bold fg-noir-1">Historique des commandes</p>
        <div class="flex items-center ml-auto w-full md:w-fit">
          <div class="w-12 h-[36px] flex items-center justify-center border-y border-l border-gris-3">
            <span class="material-icons">
              search
            </span>
          </div>
          <input
            [(ngModel)]="this._form_SearchFilter"
            (keyup)="this.updateSearch()"
            type="text"
            class="text-sm font-medium w-full md:w-64 bg-white h-[36px] outline-none border-y border-r border-gris-3"
            placeholder="Rechercher une commande">
          </div>
        </div>
        <div class="content flex-1 w-full overflow-y-scroll px-4 flex flex-col overflow-x-hidden">
          <table class="table-auto hidden md:block w-full border-collapse">
            <tr class="sticky top-0 bg-white z-10 text-center">
              <th class="text-center py-4 fg-gris-1 font-bold text-sm px-3">Numéro</th>
              <th class="text-center py-4 fg-gris-1 font-bold text-sm px-3">Date - Moment - Lieu</th>
              @if (this.acceptPayments) {
                <th class="text-center py-4 fg-gris-1 font-bold text-sm px-3">Prix</th>
              }
              <th class="text-center py-4 fg-gris-1 font-bold text-sm px-3">Convive</th>
              <th class="text-center py-4 fg-gris-1 font-bold text-sm px-3">Statut</th>
              <th class="text-center py-4 fg-gris-1 font-bold text-sm px-3 w-1/4">Actions</th>
            </tr>
            @for (h of filteredHistory; track h) {
              <tr class="font-medium text-xs text-center border-b border-gris-3">
                <td class="py-3 px-3">
                  <div class="flex items-center justify-center gap-1">
                    <span>#{{ h.id }}</span>
                    @if (h.comment && h.comment.trim().length > 0) {
                      <span class="relative group material-icons text-[1rem] fg-vert-1 cursor-help">
                        comment
                        <span
                          class="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 hidden group-hover:block w-max max-w-56 p-2 text-left text-xs font-medium normal-case bg-noir-1 text-white rounded shadow z-20 whitespace-normal">
                          {{ h.comment }}
                        </span>
                      </span>
                    }
                  </div>
                </td>
                <td class="py-3 px-3">
                  {{ this.formatDate(h.deliveryDate)}}<br>
                  {{h.mealmoment.name}}<br>
                  {{h.enterprise.name}}
                </td>
                @if (this.acceptPayments) {
                  <td class="py-3 px-3">{{ h.price|formatNumber }}€</td>
                }
                <td class="py-3 px-3">{{ h.child_name || this.getUsername() }}</td>
                <td class="py-3 px-3">
                  <div
                    class="max-w-48 w-full min-w-16 justify-between px-2 flex-row-reverse h-full rounded gap-2 text-xs font-semibold p-1 text-white flex items-center {{this.computeStatusState(h)?.classes}}">
                    <span class="material-icons">
                      {{ this.computeStatusState(h)?.icon }}
                    </span>
                    <p [innerText]="$safeNavigationMigration(this.computeStatusState(h)?.name)"></p>
                  </div>
                </td>
                <td class="py-3 px-3">
                  <div class="w-full flex items-center gap-2 justify-center">
                    <mk-action-button class="w-24 h-[40px]" [enabled]="this.isCancellable(h)" baseLabel="Annuler" baseIcon="delete" [data]="h" [callback]="this._handler_cancelOrder" />
                    @if (this.acceptPayments) {
                      <mk-action-button class="w-24 h-[40px]" [enabled]="this.acceptPayments" baseLabel="Facture" baseIcon="download" [data]="h" [callback]="this._handler_facture"/>
                    }
                    <mk-action-button class="h-[40px] w-24" [classes]="this.historyWithData.includes(h) ? 'fg-orange-1' : ''" [enabled]="h.status === 'valid'" baseLabel="Noter" [baseIcon]="this.historyWithData.includes(h) ? 'star_half' : 'star'" [data]="h" [callback]="this._handler_openNotation"/>
                  </div>
                </td>
              </tr>
            }
          </table>
          @for (h of filteredHistory; track h; let i = $index) {
            <accordeon [historyWithData]="this.historyWithData" [user]="this.user" [isAcceptPayment]="this.company?.isAcceptPayment || false" [order]="h" class="block md:hidden w-full"
              [numberOfDaysForCancelation]="$safeNavigationMigration(this.company?.numberOfDaysForCancelation)"/>
          }
        </div>
      </div>
    </div>
  }
